import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { UserConfiguration } from 'owa-graph-schema';
import * as trace from 'owa-trace';
import { convertUserConfigToGraphQLSchema } from './utils/convertUserConfigToGraphQLSchema';

interface UserConfigurationCache {
    config?: UserConfiguration;
}

const cache: UserConfigurationCache = {};

export function setConfiguration(configuration: OwaUserConfiguration) {
    try {
        const configCopy = JSON.parse(JSON.stringify(configuration));
        cache.config = convertUserConfigToGraphQLSchema(configCopy);
    } catch (e) {
        trace.errorThatWillCauseAlert('User configuration cache set failed: ' + e);
    }
}

export function getConfiguration(): UserConfiguration {
    return cache.config || {};
}
